module.exports = {"media":{"content_id":null,"video_url":null,"streamType":"audio","backgroundImage":null,"playlistType":null,"duration":0,"isLive":false,"isActiveEpg":false}}


//////////////////
// WEBPACK FOOTER
// ./src/constants/musica/pgm_musica.json
// module id = 1891
// module chunks = 0